import { CustomDialog } from "../../../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';
import { useApiInfoContextValueHook } from "../../../../../../../../../contexts/ApiInfoContext";
import { useEffect, useState } from "react";
import { SellertoolSignatureUtils } from "../../../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../../../components/backdrop/default/v1";
import { ProductOptionsApi } from "../../../../../../../../../apis/ProductOptionsApi";
import { CustomLabelInput } from "../../../../../../../../../components/input/CustomLabelInput";
import CustomBlockButton from "../../../../../../../../../components/button/CustomBlockButton";
import { v4 as uuidv4 } from 'uuid';
import { InventoryReceivesApi } from "../../../../../../../../../apis/InventoryReceivesApi";
import { useFetcher } from "../../../../../../fetcher/useFetcher";
import { customToast } from "../../../../../../../../../components/toast/custom-react-toastify/v1";
const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label{
        font-size: 14px;
        font-weight: 600;
        color: #333;
    }

    .content{
        font-size: 14px;
        font-weight: 500;
        color: #333;
        padding-left: 5px;
        margin-top: 5px;
    }

    input{
        border-radius: 3px;
        border: 1px solid #e0e0e0;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: var(--blueColor1);
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;


export function ModalCheck({
    open,
    onClose,
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const [productOption, setProductOption] = useState(null);
    const [memo, setMemo] = useState('반품/교환 회수 상품 입고');

    useEffect(() => {
        if (!returnExchange?.collectionOptionCode) {
            return;
        }

        handleReqFetchProductOptions();
    }, [returnExchange?.collectionOptionCode])

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const response = await ProductOptionsApi().searchListByOptionCodes({
            headers: headers,
            body: {
                optionCodes: [returnExchange?.collectionOptionCode]
            }
        });

        if (response?.content && response?.content.length > 0) {
            setProductOption(response?.content[0]);
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleSubmit = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        let formDatas = [];

        if (productOption?.packageYn === 'y') {
            const response = await ProductOptionsApi().searchListByPackageOptionIds({
                headers: headers,
                body: {
                    packageOptionIds: [productOption?.id]
                }
            });

            if (response?.content && response?.content?.length === 1) {
                formDatas = response?.content[0]?.packageItems?.map(packageItem => {
                    const unit = returnExchange?.inspectionPassedQuantity * packageItem?.unit;
                    const purchaseCost = packageItem?.productOption?.totalPurchasePrice;
                    return {
                        cid: null,
                        id: uuidv4(),
                        unit: unit,
                        memo: memo || '',
                        purchaseCost: purchaseCost ?? 0,
                        avgPurchaseCost: purchaseCost ?? 0,
                        createdAt: null,
                        productOptionId: packageItem?.targetOptionId,
                        deletedFlag: false,
                        returnExchangeId: returnExchange?._id,
                    }
                })
            }
        } else {
            formDatas.push({
                cid: null,
                id: uuidv4(),
                unit: returnExchange?.inspectionPassedQuantity,
                memo: memo || '',
                purchaseCost: productOption?.totalPurchasePrice ?? 0,
                avgPurchaseCost: productOption?.totalPurchasePrice ?? 0,
                createdAt: null,
                productOptionId: productOption?.id,
                deletedFlag: false,
                returnExchangeId: returnExchange?._id,
            })
        }

        const body = {
            formDatas: [...formDatas]
        }

        CustomBackdropController().showBackdrop();
        const response = await InventoryReceivesApi().createList({ headers: headers, body: body });

        if (response?.content) {
            fetcher.fetchReturnExchanges();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }

    const disabledSubmit = !productOption || !productOption?.code || !productOption?.product?.name || !productOption?.name;

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            정상제품 입고반영
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    {disabledSubmit ?
                        <>
                            <div>회수 상품정보의 상품 매칭을 확인해 주세요.</div>
                        </>
                        :
                        <>
                            <div>
                                <div className='label'>회수상품 옵션코드</div>
                                <div className='content'>{productOption?.code || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>회수상품명</div>
                                <div className='content'>{productOption?.product?.name || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>회수옵션명</div>
                                <div className='content'>{productOption?.name || '-'}</div>
                            </div>
                            <div>
                                <div className='label'>수량</div>
                                <div className='content'>{returnExchange?.inspectionPassedQuantity || '-'}</div>
                            </div>
                            <div>
                                <CustomLabelInput>
                                    <CustomLabelInput.Input
                                        type='text'
                                        value={memo}
                                        onChange={(e) => setMemo(e.target.value)}
                                    />
                                    <CustomLabelInput.Label>메모</CustomLabelInput.Label>
                                </CustomLabelInput>
                            </div>
                        </>
                    }
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        disabled={disabledSubmit}
                        onClick={handleSubmit}
                    >
                        입고반영
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}